/**
 * Minimal first-party cookie helpers used for partner-attribution persistence
 * (ref key / SubID / click_id). First-party, `SameSite=Lax`, `Secure` on HTTPS.
 */

/** 30 days, in seconds — the affiliate attribution window. */
export const ATTRIBUTION_MAX_AGE_S = 30 * 24 * 60 * 60;

export function setCookie(name: string, value: string, maxAgeSec = ATTRIBUTION_MAX_AGE_S): void {
  if (typeof document === 'undefined') return;
  const secure = typeof location !== 'undefined' && location.protocol === 'https:' ? '; Secure' : '';
  document.cookie = `${name}=${encodeURIComponent(value)}; Max-Age=${maxAgeSec}; Path=/; SameSite=Lax${secure}`;
}

export function getCookie(name: string): string | null {
  if (typeof document === 'undefined') return null;
  const escaped = name.replace(/[.$?*|{}()[\]\\/+^]/g, '\\$&');
  const match = document.cookie.match(new RegExp(`(?:^|; )${escaped}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
}

export function deleteCookie(name: string): void {
  setCookie(name, '', 0);
}

/** Re-writes an existing cookie with a fresh Max-Age (sliding expiry). No-op if absent. */
export function refreshCookie(name: string, maxAgeSec = ATTRIBUTION_MAX_AGE_S): void {
  const value = getCookie(name);
  if (value !== null) setCookie(name, value, maxAgeSec);
}
